import { Input } from 'antd';
import PropTypes from 'prop-types';
import React, { memo } from 'react';

const DynamicFieldInputText = ({ ...props }) => {
  return <Input {...props}/>;
};

DynamicFieldInputText.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func,
  rules: PropTypes.any,
};

export default memo(DynamicFieldInputText);
